import DataGrid, { Column, Item, LoadPanel, Paging, SearchPanel, Toolbar, Button as Butt, Editing, Pager } from 'devextreme-react/data-grid';
import { useCallback, useEffect, useRef, useState } from 'react';
import './ConfigEmailTemplates.scss';
import Button from 'devextreme-react/button';
import { Tooltip } from 'devextreme-react';
import DxToolbar, { Item as DxToolbarItem } from 'devextreme-react/toolbar';
import { save } from '../../images/icons';
import { Popup } from 'devextreme-react/popup';
import { useApiConfigurationEmail } from '../../api/api.configurationEmail';
import { newToast } from '../../components';

const Index = () => {
  const gridRef = useRef<DataGrid>(null);
  const { getEmailTemplates, updateEmailTemplates } = useApiConfigurationEmail();
  const [dataSource, setDataSource] = useState<any[]>([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [currentHtml, setCurrentHtml] = useState('');
  const [currentIdentifier, setCurrentIdentifier] = useState('');
  const [currentId, setCurrentId] = useState<number | null>(null);

  const fetchData = useCallback(async () => {
    try {
      gridRef.current?.instance?.beginCustomLoading('Cargando plantillas...');
      const templates = await getEmailTemplates();
      setDataSource(Array.isArray(templates) ? templates : []);
    } catch (err) {
      console.error(err);
      newToast('ERROR', 'Error cargando plantillas', 4);
      setDataSource([]);
    } finally {
      gridRef.current?.instance?.endCustomLoading();
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleView = useCallback(
    (e: any) => {
      const row = e.row?.data || e;
      const html = row?.Pco_Html || '';
      const idf = row?.Pco_Identificador || '';
      setCurrentHtml(html);
      setCurrentIdentifier(idf);
      setCurrentId(row?.Pco_Id ?? null);
      setModalVisible(true);
    },
    [setCurrentId, setCurrentHtml, setCurrentIdentifier, setModalVisible]
  );

  const handleCloseModal = useCallback(() => {
    setModalVisible(false);
    setCurrentHtml('');
    setCurrentIdentifier('');
    setCurrentId(null);
  }, []);

  const handleSaveTemplate = useCallback(async () => {
    if (!currentId) {
      newToast('ERROR', 'No hay plantilla seleccionada', 4);
      return;
    }

    try {
      await updateEmailTemplates(currentId, currentHtml || '');
      newToast('SUCCESS', 'Plantilla actualizada correctamente', 3);
      // refresh list
      fetchData();
      setModalVisible(false);
    } catch (err) {
      console.error('Error saving template', err);
      newToast('ERROR', 'Error guardando plantilla', 4);
    }
  }, [currentId, currentHtml, updateEmailTemplates, fetchData]);

  const handleCopyCode = useCallback(async () => {
    try {
      if (navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(currentHtml || '');
      } else {
        // fallback: crear textarea temporal
        const ta = document.createElement('textarea');
        ta.value = currentHtml || '';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
      }
      newToast('SUCCESS', 'Código copiado al portapapeles', 2);
    } catch (err) {
      console.error('Error copiando código', err);
      newToast('ERROR', 'No se pudo copiar el código', 4);
    }
  }, [currentHtml]);

  return (
    <div className={'view crm-contact-list'}>
      <div className={'view-wrapper view-wrapper-contact-list'}>
        <DataGrid className='grid' dataSource={dataSource} ref={gridRef} keyExpr='Pco_Id' height='100%' width={'100%'} repaintChangesOnly={false} highlightChanges={false} hoverStateEnabled={true} rowAlternationEnabled={true} showColumnLines={true}>
          <LoadPanel enabled={true} />
          <Editing allowUpdating={false} allowDeleting={false} />
          <SearchPanel visible placeholder='Buscar' />
          <Paging enabled={true} />
          <Pager visible={true} allowedPageSizes={[20, 50, 100, 'all']} displayMode='full' showPageSizeSelector={true} showInfo={true} showNavigationButtons={true} />
          <Toolbar>
            <Item location='before'>
              <div className='grid-header'>Plantillas de correo</div>
            </Item>
          </Toolbar>

          <Column dataField='Pco_Id' caption='ID' alignment='center' width={90} />
          <Column dataField='Pco_Identificador' caption='IDENTIFICADOR' alignment='left' />
          <Column type='buttons' caption='ACCIONES' width={120}>
            <Butt icon='eyeopen' text='Ver' onClick={handleView} />
          </Column>
        </DataGrid>

        {modalVisible && (
          <Popup visible={modalVisible} onHiding={handleCloseModal} title={currentIdentifier} showCloseButton fullScreen={false} width={'90%'} height={'80%'} wrapperAttr={{ class: 'config-email-modal form-popup' }}>
            <DxToolbar>
              <DxToolbarItem location='before' locateInMenu='auto' showText='inMenu' widget='dxButton'>
                <Button id='OpportunityBtn' icon={save} text='Oportunidad' stylingMode='text' onClick={handleSaveTemplate} />
                <Tooltip target={'#OpportunityBtn'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
                  Guardar plantilla
                </Tooltip>
              </DxToolbarItem>

              <DxToolbarItem location='before' locateInMenu='auto' showText='inMenu' widget='dxButton'>
                <Button id='copy' icon='copy' text='Copiar código' stylingMode='text' onClick={handleCopyCode} />
                <Tooltip target={'#copy'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
                  Copiar código al portapapeles
                </Tooltip>
              </DxToolbarItem>
            </DxToolbar>

            <div className='split-view'>
              <div className='split-left'>
                <h4>Código</h4>
                <textarea className='code-editor' value={currentHtml} onChange={(ev) => setCurrentHtml((ev.target as HTMLTextAreaElement).value)} />
              </div>
              <div className='split-right'>
                <div className='preview-block' dangerouslySetInnerHTML={{ __html: currentHtml || '<div style="color:#666">Sin contenido</div>' }} />
              </div>
            </div>
          </Popup>
        )}
      </div>
    </div>
  );
};

export default Index;
